import { render } from "./BlListPaginationSettings.vue?vue&type=template&id=1f37237e&scoped=true"
import script from "./BlListPaginationSettings.vue?vue&type=script&lang=js"
export * from "./BlListPaginationSettings.vue?vue&type=script&lang=js"

import "./BlListPaginationSettings.vue?vue&type=style&index=0&id=1f37237e&scoped=true&lang=scss"

import exportComponent from "/tmp/5e119732-5ebd-42f7-baa8-4916aa59fc29/frontend/core/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1f37237e"]])

export default __exports__